module.exports = __webpack_public_path__ + "img/seek_logo.2299d155.png";